/** Outcome of a local audit, as returned by the desktop app's preload bridge (electron/src/preload). */
export type LocalAuditOutcome =
  | { ok: true; lhr: string; reportHtml: string | null }
  | {
      ok: false
      code: 'CHROME_NOT_FOUND' | 'TIMEOUT' | 'CANCELLED' | 'RUNNER_FAILED' | 'BUSY' | 'INVALID_REQUEST' | 'FORBIDDEN'
      message: string
    }

export interface LocalAuditProgress {
  phase: string
  progress: number
  message: string
}

export interface LensDesktopBridge {
  readonly isDesktop: true
  runLocalAudit(url: string, device: 'MOBILE' | 'DESKTOP'): Promise<LocalAuditOutcome>
  onProgress(callback: (event: LocalAuditProgress) => void): () => void
  cancel(): Promise<void>
}

/** The desktop app's bridge, or null in a browser. Read at call time — never cache it at module load. */
export function getDesktopBridge(): LensDesktopBridge | null {
  const bridge = (window as Window & { lensDesktop?: LensDesktopBridge }).lensDesktop
  return bridge?.isDesktop === true ? bridge : null
}
